/**
 * MARWAN SPORTS - SIMPLE & SAFE SCRIPT
 * Handles scroll behavior and ensures arrows appear
 */

(function() {
  'use strict';

  console.log('🚀 Marwan Sports - Initializing...');

  // ====================================
  // SCROLL BEHAVIOR
  // ====================================
  
  function initScrollBehavior() {
    const header = document.querySelector('header, .shopify-section-header, .header-wrapper');
    
    if (!header) {
      console.warn('Header not found');
      return;
    }
    
    console.log('✅ Header found, setting up scroll...');
    
    function handleScroll() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
  }

  // ====================================
  // ADD DROPDOWN ARROWS (IF MISSING)
  // ====================================
  
  function ensureDropdownArrows() {
    console.log('➡️ Checking dropdown arrows...');
    
    // Find all details/summary elements (Shopify's dropdown system)
    const summaries = document.querySelectorAll('header details summary, .header details summary');
    
    // summaries.forEach(summary => {
    //   // Only add if arrow doesn't exist
    //   if (!summary.textContent.includes('▼')) {
    //     const span = document.createElement('span');
    //     span.textContent = ' ▼';
    //     span.style.fontSize = '9px';
    //     span.style.marginLeft = '4px';
    //     summary.appendChild(span);
    //     console.log('✅ Added arrow to:', summary.textContent.trim());
    //   }
    // });
  }

  // ====================================
  // FIX ICON SIZES (ONCE)
  // ====================================
  
  function fixIconSizes() {
    console.log('🔧 Fixing icon sizes...');
    
    const icons = document.querySelectorAll('header svg, .header svg');
    
    icons.forEach(icon => {
      icon.setAttribute('width', '24');
      icon.setAttribute('height', '24');
      icon.setAttribute('stroke-width', '2.5');
    });
    
    console.log(`✅ Fixed ${icons.length} icons`);
  }

  // ====================================
  // MAIN INIT
  // ====================================
  
  function init() {
    initScrollBehavior();
    ensureDropdownArrows();
    fixIconSizes();
    
    console.log('✅ Marwan Sports - Ready!');
  }

  // ====================================
  // RUN ON PAGE LOAD
  // ====================================
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Run again after slight delay (for slow-loading elements)
  window.addEventListener('load', function() {
    setTimeout(init, 300);
  });

})();